import React, { useState, useEffect } from 'react';
import { Button, TextField, Box, Typography, Container } from '@mui/material';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate, Link } from 'react-router-dom';

const Login = ({ isLoggedIn, setIsLoggedIn }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const csrfToken = Cookies.get('XSRF-TOKEN');
            const credentials = `${username}:${password}`;
            const encodedCredentials = btoa(credentials);
            const params = new URLSearchParams();
            params.append('username', username);
            params.append('password', password);

            await axios.post('/login', params, {
                headers: {
                    'Authorization': `Basic ${encodedCredentials}`,
                    'X-XSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            Cookies.set('isLoggedIn', 'true');
	    setIsLoggedIn(true);
	    navigate('/staff');
        } catch (error) {
            console.error('Login error', error);
            setError('Invalid username or password');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <Box component="form" onSubmit={e => e.preventDefault()} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && <Typography color="error">{error}</Typography>}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        onClick={handleLogin}
                    >
                        Sign In
                    </Button>
                </Box>
		{isLoggedIn && (
  			<Box mt={2}>
    				<Link to="/staff" style={{ textDecoration: 'none', color: 'blue' }}>
      					Go to Staff Page
    				</Link>
  			</Box>
		)}
            </Box>
        </Container>
    );
};

export default Login;
